"use strict";

import { NgModule } from "@angular/core";
import { WindowService } from "./window.service";

@NgModule({
  providers: [WindowService]
})
export class WindowModule {}
